import React from "react";
import "./questionButtons.scss";
import PropTypes from "prop-types";

const QuestionButton = ({
  number,
  variant,
  currentQuestion,
  handleQuestionChange,
}) => {
  // ["answered","unanswered","viewed"]
  let bgColor = "";
  switch (variant) {
    case "answered":
      bgColor = "bg-success btn-success";
      break;
    case "unanswered":
      bgColor = " ";
      break;
    case "viewed":
      bgColor = "bg-secondary btn-secondary";
      break;
    case "current":
      bgColor = "bg-primary btn-primary";
      break;
    default:
      bgColor = "";
      break;
  }

  return (
    <div
      className={`l-num ${bgColor} ${currentQuestion ? "" : ""}`}
      onClick={handleQuestionChange}
      id="demo"
    >
      <p className="h5 mb-0"> {number}</p>
    </div>
  );
};
QuestionButton.propTypes = {
  variant: PropTypes.oneOf(["answered", "unanswered", "viewed", "current"])
    .isRequired,
  number: PropTypes.string.isRequired,
  current: PropTypes.bool,
};

export default QuestionButton;
